// time parameter needs to be a string: ex '2:00'
// working example: time = '1:00', func output: 60000
const formatTimeToMiliSeconds = time =>
  (Number(time.format('m:ss').split(':')[0]) * 60 + Number(time.format('m:ss').split(':')[1])) * 1000;

export default formatTimeToMiliSeconds;
